<div class="card border-0 rounded-0 h-10 mb-4">
    <form (ngSubmit)="onSubmit()" *ngIf="assessmentSearchForm" [formGroup]="assessmentSearchForm">
        <div class="card-body">


            <div class="col-md-12 d-flex flex-wrap">
                <div class="form-group col-md-3">
                    <label for="exampleInputEmail1">ওয়ার্ড অনুসারে</label>
                    <select formControlName="ward_number" name="ward_number" class="form-control rounded-0">
                    <option value="0">সব ওয়ার্ড</option>
                    <option *ngFor="let ward of wardList" [value]="ward.ward_number">
                      {{ward.ward_name}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                    <label for="exampleInputEmail1">হোল্ডিং নং অনুসারে</label>
                    <input formControlName="holding_number" type="text" name="requestedPersonName" class="form-control rounded-0" id="husername" aria-describedby="emailHelp" placeholder="হোল্ডিং নং">
                </div>
                <div class="form-group col-md-3">
                    <label for="exampleInputEmail1">গ্রাম অনুসারে</label>
                    <input formControlName="gram_or_rasta" type="text" name="requestedPersonName" class="form-control rounded-0" id="husername" aria-describedby="emailHelp" placeholder="গ্রামের নাম">
                </div>
            </div>
        </div>
        <div class="col-md-12">

            <div class="d-flex justify-content-center">
                <button type="submit" class="btn btn-lightning rounded-0 mb-2 mr-2">খুঁজুন</button>
                <button [useExistingCss]="true" printSectionId="demo" ngxPrint class="btn btn-lightning rounded-0 mb-2 mr-2">প্রিন্ট করুন</button>
                <button (click)="exportTableToExcel()" type="submit" class="btn btn-lightning rounded-0 mb-2 mr-2">Excel প্রিন্ট করুন</button>
            </div>

        </div>
    </form>
</div>

<div class="card border-0 rounded-0 h-10">
    <div id="demo" class="card-body">


        <table id="demo" class="">
            <thead>
                <tr>
                    <td colspan="12" class="p-4">
                        <div class="table-heading"> {{unionDomain.unionData.union_name}}</div><br>{{unionDomain.unionData.upozilla_name}} , {{unionDomain.unionData.zilla_name}}</td>
                </tr>
                <tr>
                    <!-- <th class="col">ক্রম</th> -->
                    <th class="col">হোল্ডিং</th>
                    <th class="col">নাম</th>
                    <th class="col">পিতা/স্বামী</th>
                    <th class="col">ওয়ার্ড নং</th>
                    <th class="col">ঠিকানা</th>
                    <th class="col">মোবাইল</th>
                    <th class="col">পেশা</th>
                    <th class="col">বাড়ির ধরণ</th>
                    <th class="col">বার্ষিক মূল্যমান</th>
                    <th class="col">ধার্য্যকৃত ট্যাক্স</th>
                    <th class="col">কিউআর কোড</th>
                </tr>
            </thead>
            <tbody>
                <tr class="py-2" *ngFor="let assessment of assessmentList">
                    <!-- <th>{{assessment.id_number}}</th> -->
                    <td>{{assessment.holding_number}}</td>
                    <td>{{assessment.name}}</td>
                    <td>{{assessment.gurdian_name}}</td>
                    <td>{{unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(assessment.ward_number.toString())}}</td>
                    <td>{{assessment.gram_or_rasta}}</td>
                    <td>{{assessment.mobile_number}}</td>
                    <td>{{unionDomain.peshaNumberToPeshaName(assessment.pesha)}}</td>
                    <td>{{unionDomain.khanarDhoronNumberToKhanarDhoronName(assessment.khanar_dhoron)}}</td>
                    <td>{{unionDomain.khanarDhoronNumberToKhanarMulloAndTax(assessment.khanar_dhoron).khanarMullo}}</td>
                    <td>{{unionDomain.khanarDhoronNumberToKhanarMulloAndTax(assessment.khanar_dhoron).khanarTax}}</td>
                    <td class="py-2">
                        <qrcode [elementType]="'img'" [qrdata]="unionDomain.qrCodeInitialString+assessment.qr_code" [width]="80" [errorCorrectionLevel]="'L'"></qrcode>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>